import { useContext } from 'react';

import { DemandDefinitionCalculationContext } from '../components/DemandDefinitionCalculationContext';

export const useDemandDefinitionCalculationContext = () => {
    const context = useContext(DemandDefinitionCalculationContext);

    if (!context) {
        throw new Error('useDemandDefinitionCalculationContext must be used within DemandDefinitionCalculationContext');
    }

    return context;
};
